// De iconenset van de Jmix-editor, letterlijk overgenomen uit comm-editor.js. Eén set van 24×24
// lijntekeningen op stroke 1.7 — dezelfde die de bron gebruikt, zodat elk knopje er hetzelfde
// uitziet. lucide zou hier niet werken: die tekent anders en dan valt de werkbalk uit de toon.

const PADEN: Record<string, string> = {
  doc: '<path d="M6 2h7l5 5v15H6z"/><path d="M13 2v5h5"/>',
  undo: '<path d="M9 7L4 12l5 5"/><path d="M4 12h11a5 5 0 0 1 0 10h-1"/>',
  redo: '<path d="M15 7l5 5-5 5"/><path d="M20 12H9a5 5 0 0 0 0 10h1"/>',
  bold: '<path d="M7 4h7a4 4 0 0 1 0 8H7zM7 12h8a4 4 0 0 1 0 8H7z"/>',
  italic: '<path d="M19 4h-7M14 20H7M15 4L9 20"/>',
  underline: '<path d="M7 4v7a5 5 0 0 0 10 0V4M5 21h14"/>',
  strike: '<path d="M5 12h14M8 7a4 3 0 0 1 8 0M16 16a4 3 0 0 1-8 0"/>',
  chevdown: '<path d="M6 9l6 6 6-6"/>',
  chevright: '<path d="M9 6l6 6-6 6"/>',
  color: '<path d="M5 20h14M7 16l5-12 5 12M9 11h6"/>',
  highlight: '<path d="M4 20h16M6 16l8-8 4 4-8 8H6z"/>',
  alignLeft: '<path d="M4 6h16M4 12h10M4 18h13"/>',
  alignCenter: '<path d="M4 6h16M7 12h10M5 18h14"/>',
  alignRight: '<path d="M4 6h16M10 12h10M7 18h13"/>',
  alignJustify: '<path d="M4 6h16M4 12h16M4 18h16"/>',
  bullet: '<path d="M9 6h11M9 12h11M9 18h11"/><circle cx="4.5" cy="6" r="1.2"/><circle cx="4.5" cy="12" r="1.2"/><circle cx="4.5" cy="18" r="1.2"/>',
  ordered: '<path d="M10 6h10M10 12h10M10 18h10M4 5h1v4M4 9h2"/>',
  indent: '<path d="M4 6h16M10 12h10M10 18h10M4 10v4l3-2z"/>',
  outdent: '<path d="M4 6h16M10 12h10M10 18h10M7 10v4l-3-2z"/>',
  fill: '<path d="M5 11l6-6 7 7-6 6z"/><path d="M11 5L9 3"/><path d="M19 15s2 2.2 2 3.5a2 2 0 0 1-4 0c0-1.3 2-3.5 2-3.5z"/>',
  nofill: '<path d="M5 11l6-6 7 7-6 6z"/><path d="M4 20L20 4"/>',
  table: '<rect x="4" y="5" width="16" height="14" rx="1"/><path d="M4 10h16M4 15h16M10 5v14"/>',
  image: '<rect x="4" y="5" width="16" height="14" rx="2"/><circle cx="9" cy="10" r="1.6"/><path d="M5 18l5-5 4 4 2-2 3 3"/>',
  quote: '<path d="M7 7H4v5h3l-1 4M17 7h-3v5h3l-1 4"/>',
  code: '<path d="M9 8l-5 4 5 4M15 8l5 4-5 4"/>',
  more: '<circle cx="5" cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="19" cy="12" r="1.6"/>',
  variable: '<path d="M8 4C5 8 5 16 8 20M16 4c3 4 3 12 0 16"/><path d="M9 12h6"/>',
  logo: '<rect x="4" y="6" width="16" height="12" rx="2"/><path d="M4 14l4-4 4 4 3-3 5 5"/>',
  sign: '<path d="M3 18s4-1 7-5 4-7 6-7 2 3 0 5-5 2-5 2"/><path d="M3 21h18"/>',
  qr: '<rect x="4" y="4" width="6" height="6"/><rect x="14" y="4" width="6" height="6"/><rect x="4" y="14" width="6" height="6"/><path d="M14 14h2v2M18 14h2M20 16v2h-2M16 18v2h-2"/>',
  rule: '<path d="M4 12h16"/>',
  pagebreak: '<path d="M6 3h9l3 3v4M6 3v6M18 14v7H6v-7M3 12h18"/>',
  kopvoet: '<rect x="5" y="3" width="14" height="18" rx="1"/><path d="M5 7h14M5 17h14M8 11h8M8 13.5h6"/>',
  eye: '<path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="2.5"/>',
  eyeoff: '<path d="M2 12s4-7 10-7c2 0 3.6.5 5 1.3M22 12s-4 7-10 7c-2 0-3.6-.5-5-1.3"/><path d="M4 4l16 16"/>',
  check: '<path d="M5 13l4 4L19 7"/>',
  close: '<path d="M6 6l12 12M18 6L6 18"/>',
  history: '<path d="M3 12a9 9 0 1 0 3-6.7L3 8M3 4v4h4"/><path d="M12 8v5l3 2"/>',
  restore: '<path d="M3 8l4-4 4 4M7 4v9a5 5 0 0 0 5 5h6"/>',
  print: '<path d="M7 9V3h10v6M7 18H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2M7 14h10v7H7z"/>',
  process: '<rect x="3" y="4" width="6" height="4" rx="1"/><rect x="15" y="16" width="6" height="4" rx="1"/><path d="M6 8v5a3 3 0 0 0 3 3h6"/>',
  search: '<circle cx="11" cy="11" r="6"/><path d="M20 20l-3.5-3.5"/>',
  grip: '<circle cx="9" cy="6" r="1.3"/><circle cx="15" cy="6" r="1.3"/><circle cx="9" cy="12" r="1.3"/><circle cx="15" cy="12" r="1.3"/><circle cx="9" cy="18" r="1.3"/><circle cx="15" cy="18" r="1.3"/>',
  text: '<path d="M5 6h14M12 6v13M9 19h6"/>',
  block: '<rect x="4" y="5" width="16" height="14" rx="2"/>',
  cols2: '<rect x="4" y="5" width="7" height="14" rx="1"/><rect x="13" y="5" width="7" height="14" rx="1"/>',
  title: '<path d="M5 6h14M12 6v13"/>',
  space: '<path d="M5 4v16M19 4v16M5 12h14"/>',
  phone: '<rect x="8" y="3" width="8" height="18" rx="2"/><path d="M11 18h2"/>',
  tablet: '<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M11 18h2"/>',
  desktop: '<rect x="3" y="4" width="18" height="12" rx="2"/><path d="M8 20h8M12 16v4"/>',
  fullscreen: '<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>',
  ai: '<path d="M12 3l1.8 4.7L18.5 9.5 13.8 11.3 12 16l-1.8-4.7L5.5 9.5l4.7-1.8z"/><path d="M18 15l.7 1.9 1.9.7-1.9.7-.7 1.9-.7-1.9-1.9-.7 1.9-.7z"/>',
  translate: '<path d="M4 5h9M8 3v2c0 4-2 7-5 8M6 9c0 3 3 5 7 5"/><path d="M13 21l4-9 4 9M14.5 17h5"/>',
  warn: '<path d="M12 3l9 16H3z"/><path d="M12 10v4M12 17.5v.5"/>',
  move: '<path d="M12 2v20M2 12h20M12 2l-3 3M12 2l3 3M12 22l-3-3M12 22l3-3M2 12l3-3M2 12l3 3M22 12l-3-3M22 12l-3 3"/>',
  send: '<path d="M22 2L11 13M22 2l-7 20-4-9-9-4z"/>',
  transfer: '<path d="M4 8h13l-3-3M20 16H7l3 3"/>',
  repeat: '<path d="M17 2l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 22l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>',
  settings: '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1V21a2 2 0 1 1-4 0v-.1a1.6 1.6 0 0 0-2.7-1.1l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0-1.1-2.7H3a2 2 0 1 1 0-4h.1A1.6 1.6 0 0 0 4.2 7.4l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 2.7-1.1V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 2.7 1.1l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0 1.1 2.7H21a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1z"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 8v.5M11 12h1v4h1"/>',
  user: '<circle cx="12" cy="8" r="3.5"/><path d="M5 20c0-3.3 3-5.5 7-5.5s7 2.2 7 5.5"/>',
  users: '<circle cx="9" cy="9" r="3"/><path d="M3 19c0-2.8 2.7-4.5 6-4.5s6 1.7 6 4.5"/><path d="M16 7a3 3 0 0 1 0 5.5M21 19c0-2.3-1.6-3.9-4-4.4"/>',
  paw2: '<ellipse cx="6" cy="11" rx="1.6" ry="2.1"/><ellipse cx="10" cy="8" rx="1.6" ry="2.3"/><ellipse cx="14" cy="8" rx="1.6" ry="2.3"/><ellipse cx="18" cy="11" rx="1.6" ry="2.1"/><path d="M12 13c-2.6 0-4.4 1.8-4.4 3.9 0 1.7 1.3 2.6 2.6 2.6.8 0 1.3-.4 1.8-.4s1 .4 1.8.4c1.3 0 2.6-.9 2.6-2.6C16.4 14.8 14.6 13 12 13z"/>',
  home: '<path d="M4 11l8-7 8 7"/><path d="M6 10v9h12v-9"/>',
  building: '<rect x="5" y="3" width="14" height="18" rx="1"/><path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2"/>',
  calendar: '<rect x="4" y="5" width="16" height="16" rx="2"/><path d="M4 9h16M8 3v4M16 3v4"/>',
  link: '<path d="M10 13a5 5 0 0 0 7 0l2-2a5 5 0 0 0-7-7l-1 1"/><path d="M14 11a5 5 0 0 0-7 0l-2 2a5 5 0 0 0 7 7l1-1"/>',
  scissors: '<circle cx="6" cy="6" r="2.5"/><circle cx="6" cy="18" r="2.5"/><path d="M8 8l12 8M8 16l12-8"/>',
  shield: '<path d="M12 3l8 3v6c0 4.5-3.2 7.5-8 9-4.8-1.5-8-4.5-8-9V6z"/>',
  mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M4 7l8 6 8-6"/>',
};

/** Eén icoon uit de set. Onbekende naam levert een leeg vierkant op, nooit een crash. */
export function CeIcon({ naam, className }: { naam: string; className?: string }) {
  return (
    <svg
      className={`ce-ic${className ? " " + className : ""}`}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: PADEN[naam] ?? "" }}
    />
  );
}

/** Het pootje uit het briefpapier van de bron. */
export function CePaw({ className }: { className?: string }) {
  return (
    <svg className={`ce-ic${className ? " " + className : ""}`} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <ellipse cx="6" cy="11" rx="1.7" ry="2.3" />
      <ellipse cx="10" cy="7.5" rx="1.7" ry="2.5" />
      <ellipse cx="14" cy="7.5" rx="1.7" ry="2.5" />
      <ellipse cx="18" cy="11" rx="1.7" ry="2.3" />
      <path d="M12 12.4c-2.9 0-4.9 2-4.9 4.4 0 1.9 1.4 2.9 2.9 2.9.9 0 1.5-.5 2-.5s1.1.5 2 .5c1.5 0 2.9-1 2.9-2.9 0-2.4-2-4.4-4.9-4.4z" />
    </svg>
  );
}
